import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { UserName } from "components/common/UserName";
import { Nav } from "reactstrap";

let userSlice;

function Sidebar(props) {
  const location = useLocation();
  const sidebar = useRef();
  const permissionRef = useRef(null);
  const settingsRef = useRef(null);

  const [openPermissions, setOpenPermissions] = useState(false);
  const [openTools, setOpenTools] = useState(false);
  const [openReports, setOpenReports] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNavLinkClick = () => {
    if (window.innerWidth <= 991) props.toggleSidebar();
  };

  const activeRoute = (routeName) => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    return "/" + pathSegments[pathSegments.length - 1] === routeName ? 'active' : "";
  };

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  useEffect(() => {
    // Open accordion based on current URL
    if (location.pathname.includes("permissions")) setOpenPermissions(true);
    else setOpenPermissions(false);

    const SettingsCollapse = [
      'tools/language', 'tools/state', 'tools/courtrooms', 'tools/jurisdictions', 'tools/party-types',
      'tools/case-types', 'tools/hearing-types', 'tools/poeta',
      'tools/job-locations', 'tools/holiday-rates', 'tools/miscellaneous-rates'
    ];

    setOpenTools(SettingsCollapse.some(section => location.pathname.includes(section)));
    setOpenReports(location.pathname.includes('reports/'));
  }, [location.pathname]);

  const handleLogout = () => {
    navigate('/login', { replace: true });
    dispatch(userSlice.logout());
  };

  const mainRoutes = props.routes;

  function IncludesUrl(baseUrl) {
    return props.routes.map(i => i?.path).includes(baseUrl);
  }

  const SettingsCollapse = [
    'tools/language', 'tools/state', 'tools/courtrooms', 'tools/jurisdictions', 'tools/party-types',
    'tools/case-types', 'tools/hearing-types', 'tools/poeta',
    'tools/job-locations', 'tools/holiday-rates', 'tools/miscellaneous-rates'
  ];

  const ReportsCollapse = [
    'reports/non-invoiced-jobs', 'reports/raw-data'
  ];

  return (
    <div className={`sidebar ${props.isSidebarOpen ? "toggled" : ""}`} data-color={props.bgColor} data-active-color={props.activeColor}>
      <div className="logo">
        <button className="close_side" onClick={props.toggleSidebar}>✕</button>
        <Link to="/" className="simple-text logo-mini">
          <div className="logo-img">
            <img src="/images/logo-nav.png" alt="react-logo" />
            <img src="/images/logo-fill.png" alt="react-logo" />
          </div>
        </Link>
      </div>

      <div className="side_user_row">
        <div className="side_user_image">
          <img src="/images/default-person.png" alt="" />
        </div>
        <div className="side_user_title">
          <span>Welcome,</span>
          <UserName name={props.user?.user?.name} lastName={props.user?.user?.last_name} />
        </div>
      </div>

      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          <li><p className="nav_head">General</p></li>

          {mainRoutes.map((prop, key) =>
            !prop?.subRoute && (
              <li className={activeRoute(prop.path) + (prop.pro ? " active-pro" : "")} key={key}>
                <NavLink to={prop.layout + prop.path} className="nav-NavLink" onClick={handleNavLinkClick}>
                  <div className="line_wrap">
                    <img src={prop.icon} alt="side" />
                    <img src={prop.iconActive} alt="side" />
                    <h2>{prop.title}</h2>
                  </div>
                </NavLink>
              </li>
            )
          )}

          {/* Admins — visible only to the 'admin' role */}
          {props?.user?.role === 'admin' && (
            <li className={activeRoute('admins')}>
              <NavLink to="/admins" className="nav-NavLink" onClick={handleNavLinkClick}>
                <div className="line_wrap">
                  <img src="/images/admin.png" alt="side" />
                  <img src="/images/admin-active.png" alt="side" />
                  <h2>Admins</h2>
                </div>
              </NavLink>
            </li>
          )}

          {/* Permissions Accordion */}
          {(props?.user?.role === 'admin' || props?.user?.role === 'super_admin') && (
            <li>
              <div className="accordion border-0">
                <div className="accordion-item bg-transparent border-0 text-white">
                  <h2 className="accordion-header" id="headingpermission">
                    <button
                      ref={permissionRef}
                      className={`btn_slide accordion-button shadow-none bg-transparent text-white ${openPermissions ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => setOpenPermissions(!openPermissions)}
                    >
                      <img src="/images/manage.png" alt="" />
                      Permissions
                    </button>
                  </h2>
                  {openPermissions && (
                    <ul className="accordion-body py-0 bg_gray">
                      <li>
                        <NavLink to="/permissions/groups" className="nav-NavLink" onClick={handleNavLinkClick}>
                          <div className="line_wrap">
                            <img src="/images/meeting-place.png" alt="side" />
                            <img src="/images/meeting-place-active.png" alt="side" />
                            <h2>User Groups</h2>
                          </div>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/permissions/sub-users" className="nav-NavLink" onClick={handleNavLinkClick}>
                          <div className="line_wrap">
                            <img src="/images/admin.png" alt="side" />
                            <img src="/images/admin-active.png" alt="side" />
                            <h2>Sub Users</h2>
                          </div>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </div>
              </div>
            </li>
          )}

          {/* Tools Accordion */}
          {SettingsCollapse.some(IncludesUrl) && (
            <li>
              <div className="accordion border-0">
                <div className="accordion-item bg-transparent border-0 text-white">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      ref={settingsRef}
                      className={`btn_slide accordion-button shadow-none bg-transparent text-white ${openTools ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => setOpenTools(!openTools)}
                    >
                      <img src="/images/tool.png" alt="" />
                      Tools
                    </button>
                  </h2>
                  {openTools && (
                    <ul className="accordion-body py-0 bg_gray">
                      {SettingsCollapse.map(
                        section =>
                          IncludesUrl(section) && (
                            <li key={section}>
                              <NavLink to={`/${section}`} className="nav-NavLink" onClick={handleNavLinkClick}>
                                <div className="line_wrap">
                                  <img
                                    src={`/images/${section.includes('language') ? 'language' :
                                        section.includes('state') ? 'state' :
                                          section.includes('job-locations') ? 'location_regular' :
                                            section.includes('holiday-rates') ? 'holiday_regular' :
                                              section.includes('case-types') ? 'case_regular' :
                                                section.includes('party-types') ? 'party_regular' :
                                                section.includes('hearing-types') ? 'hearing_regular' :
                                                section.includes('miscellaneous-rates') ? 'rates_regular' :
                                                section.includes('poeta') ? 'document_regular' :
                                                  'city'
                                      }.png`}
                                    alt="side"
                                  />
                                  <img
                                    src={`/images/${section.includes('language') ? 'language-active' :
                                        section.includes('state') ? 'state-active' :
                                          section.includes('job-locations') ? 'location_solid' :
                                            section.includes('holiday-rates') ? 'holiday_solid' :
                                              section.includes('case-types') ? 'case_solid' :
                                                section.includes('party-types') ? 'party_solid' :
                                                section.includes('hearing-types') ? 'hearing_solid' :
                                                section.includes('poeta') ? 'document_solid' :
                                                  'city-active'
                                      }.png`}
                                    alt="side"
                                  />
                                  <h2>
                                    {section.includes('language-tiers') ? 'Language Tiers' :
                                      section.includes('language') ? 'Languages' :
                                        section.includes('state') ? 'States' :
                                          section.includes('courtrooms') ? 'Courtrooms' :
                                          section.includes('jurisdictions') ? 'Jurisdictions' :
                                            section.includes('party-types') ? 'Party Types' :
                                              section.includes('case-types') ? 'Case Types' :
                                                section.includes('hearing-types') ? 'Hearing Types' :
                                                  section.includes('holiday-rates') ? 'Holiday Rates' :
                                                    section.includes('miscellaneous-rates') ? 'Miscellaneous Rates' :
                                                      section.includes('poeta') ? 'POETA' :
                                                        section.includes('job-locations') ? 'Job Locations' :
                                                          'Cities'
                                    }
                                  </h2>
                                </div>
                              </NavLink>
                            </li>
                          )
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </li>
          )}

          {/* Reports Accordion */}
          {ReportsCollapse.some(IncludesUrl) && (
            <li>
              <div className="accordion border-0">
                <div className="accordion-item bg-transparent border-0 text-white">
                  <h2 className="accordion-header" id="headingReports">
                    <button
                      className={`btn_slide accordion-button shadow-none bg-transparent text-white ${openReports ? "" : "collapsed"}`}
                      type="button"
                      onClick={() => setOpenReports(!openReports)}
                    >
                      <img src="/images/document_regular.png" alt="" />
                      Reports
                    </button>
                  </h2>
                  {openReports && (
                    <ul className="accordion-body py-0 bg_gray">
                      {ReportsCollapse.map(
                        section =>
                          IncludesUrl(section) && (
                            <li key={section}>
                              <NavLink to={`/${section}`} className="nav-NavLink" onClick={handleNavLinkClick}>
                                <div className="line_wrap">
                                  <img src="/images/rates_regular.png" alt="side" />
                                  <img src="/images/rates_solid.png" alt="side" />
                                  <h2>
                                    {section.includes('non-invoiced-jobs') ? 'Non Invoiced Jobs' : 'Raw Data'}
                                  </h2>
                                </div>
                              </NavLink>
                            </li>
                          )
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </li>
          )}

          {/* Logout */}
          <li>
            <a href="" onClick={handleLogout} className="nav-NavLink p-0">
              <div className="line_wrap wrap_logout">
                <img src='/images/LogOut.png' alt="side" />
                <img src='/images/LogOut-fill.png' alt="side" />
                <h2>Log Out</h2>
              </div>
            </a>
          </li>

        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;